import {
  // SET_SURVEY_QUESTIONS,
  SET_SURVEY_PRE,
  SET_SURVEY_POST
  // SET_SURVEY_SHARP_BRAINS
} from '../mutation-types'

// initial state
const state = {
  // questions: [],
  pre: [],
  post: []
  // sharp_brains: []
}

// mutations
const mutations = {
  /*
  [SET_SURVEY_QUESTIONS](state, survey) {
    state.questions = survey
  },
  */
  [SET_SURVEY_PRE](state, survey) {
    state.pre = survey
  },
  [SET_SURVEY_POST](state, survey) {
    state.post = survey
  }
  // [SET_SURVEY_SHARP_BRAINS](state, survey) {
  //   state.sharp_brains = survey
  // }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/survey/store.js